module.exports = {"engravedIdLabel":"OV-chipkaart number","checkEligibilityButton":"Please check your booking","productConfigurationLabel":"Select the product you wish to purchase","configurationForm":{"submit":"Select product"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/special-sale.json
// module id = ZzRn
// module chunks = 1